export const APP_COMMIT = "5bd90c4316d7d8b8675ad6e85d32a60004776992";
export const DESIRED_IAC_VERSIONS: Readonly<Record<string, string>> = {"avd":"c3aef8b27a54","base":"c91550fcb440","swa":"173622669dc4"};
